import { useFrame, useThree } from "@react-three/fiber";
import { useEffect, useRef, useMemo } from "react";
import { CatmullRomCurve3, DoubleSide, Mesh, MeshStandardMaterial, TubeGeometry, Vector3 } from "three";
import { findObjectStartsWithKey } from "../../../../utils/FindObjects";

const MainSpindleTubes = ({ object3d, ...props }) => {
  const tube1 = useRef();
  const tube2 = useRef();

  const { scene } = useThree();

  const tube1Start = useMemo(() => {
    return findObjectStartsWithKey("Tube_1_Start", object3d);
  }, []);

  const tube1End = useMemo(() => {
    return findObjectStartsWithKey("Tube_1_main_end", object3d);
  }, []);

  const [startPosition, handle1, handle2, handleEnd1, targetPos] = useMemo(() => {
    var vectors = [];
    for (let index = 0; index < 5; index++) {
      vectors.push(new Vector3());
    }
    return vectors;
  }, []);

  const handle1Direction = useMemo(() => {
    return new Vector3(0.15, -1.0, 0.0).multiplyScalar(0.05);
  });

  const handle2Direction = useMemo(() => {
    return new Vector3(0.25, -0.2, 0.0).multiplyScalar(0.05);
  });

  const handleEnd1Direction = useMemo(() => {
    return new Vector3(-0.1, 0.5, 0.0151).multiplyScalar(0.1);
  });

  const getTube1Curve = () => {
    tube1Start.getWorldPosition(startPosition);

    tube1Start.getWorldPosition(handle1);

    // var startQuat = new Quaternion();

    // tube1Start.getWorldQuaternion(startQuat);

    handle1.add(handle1Direction);

    handle2.copy(handle1);
    handle2.add(handle2Direction);

    tube1End.getWorldPosition(handleEnd1);

    handleEnd1.add(handleEnd1Direction);

    tube1End.getWorldPosition(targetPos);

    var Curve1 = new CatmullRomCurve3([
      startPosition,
      handle1,
      // handle2,
      handleEnd1,
      targetPos,
    ]);

    return Curve1;
  };

  const tube2Start = useMemo(() => {
    return findObjectStartsWithKey("Tube_2_start", object3d);
  }, []);

  const tube2End = useMemo(() => {
    return findObjectStartsWithKey("Tube_2_main_end", object3d);
  }, []);

  const handle1Direction2 = useMemo(() => {
    return new Vector3(0.1, -1.0, 0.1).multiplyScalar(0.05);
  });

  const handle2Direction2 = useMemo(() => {
    return new Vector3(0.9, 0.0, 0.0).multiplyScalar(0.1);
  });

  const handleEnd1Direction2 = useMemo(() => {
    return new Vector3(-0.15, 0.5, -0.31).multiplyScalar(0.051);
  });

  const getTube2Curve = () => {
    tube2Start.getWorldPosition(startPosition);

    tube2Start.getWorldPosition(handle1);

    handle1.add(handle1Direction2);

    handle2.copy(handle1);
    handle2.add(handle2Direction2);

    tube2End.getWorldPosition(handleEnd1);

    handleEnd1.add(handleEnd1Direction2);

    tube2End.getWorldPosition(targetPos);

    var Curve1 = new CatmullRomCurve3([
      startPosition,
      handle1,
      // handle2,
      handleEnd1,
      targetPos,
    ]);

    return Curve1;
  };

  useEffect(() => {
    var tubeGeo = new TubeGeometry(getTube1Curve(), 10, 0.018);
    var tubeGeo2 = new TubeGeometry(getTube2Curve(), 10, 0.018);

    var tubeMat = new MeshStandardMaterial({
      // color: 0x0d3a8a,
      color: 0x1d242b,
      metalness: 0.1,
      roughness: 0.8,
      side: DoubleSide,
    });
    var tubeMesh = new Mesh(tubeGeo, tubeMat);
    var tubeMesh2 = new Mesh(tubeGeo2, tubeMat);

    scene.add(tubeMesh);
    tube1.current = tubeMesh;

    scene.add(tubeMesh2);
    tube2.current = tubeMesh2;

    return () => {
      // tube1.current.dispose();
      scene.remove(tube1.current);
      // tube2.current.dispose();
      scene.remove(tube2.current);
    };
  }, []);

  useFrame(() => {
    if (tube1.current) {
      var currentGeo = tube1.current.geometry;
      tube1.current.geometry = new TubeGeometry(getTube1Curve(), 30, 0.018);
      currentGeo.dispose();

      var currentGeo2 = tube2.current.geometry;
      tube2.current.geometry = new TubeGeometry(getTube2Curve(), 30, 0.018);
      currentGeo2.dispose();
    }
  });

  return null;
};

export default MainSpindleTubes;
